import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 62.5%;
    font-family: 'Pretendard', sans-serif;
  }
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, menu, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  main, menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, main, menu, nav, section {
    display: block;
  }
  /* HTML5 hidden-attribute fix for newer browsers */
  *[hidden] {
      display: none;
  }
  body {
    line-height: 1;
  }
  menu, ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  * {
    box-sizing: border-box;
  }
  body {
    font-weight: 300;
    font-family: inherit;
    background-color:${(props) => props.theme.bgColor};
    color:${(props) => props.theme.textDefaultColor};
    line-height: 1.2;
  }
  a {
    text-decoration:none;
    color:inherit;
  }

  * {
    -webkit-tap-highlight-color: transparent; /* iOS/Android */
    -webkit-focus-ring-color: transparent;
    outline: none;
  }

  a, button {
    -webkit-tap-highlight-color: transparent;
    outline: none;
  }

  ::placeholder {
    color: #a1a1a1;
  }

  html, body {
    -webkit-tap-highlight-color: rgba(0,0,0,0); /* 파란색 하이라이트 제거 */
  }

  :root {
  --active-color: #242629; /* 활성화된 색상 */
  --non-active-color: #CECECE; /* 비활성화된 색상 */
}
`;

export default GlobalStyle;
